import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AUTH_SERVER_URL } from '../../config';
import { FieldOfNews, News } from '../models/news-model';
import { OrderBy } from '../utils/constant';

import { ConnectionService } from './connection.service';

const AUTH_GET_NEWS = `${ AUTH_SERVER_URL }/v1/news:external`;
const GET_ATTACHMENT_URL = `${ AUTH_SERVER_URL }/v1/filedownload:external`;

@Injectable({ providedIn: 'root' })
export class NewsService {
	constructor(
		private readonly http: HttpClient,
		private readonly connectionService: ConnectionService
	) {}

	getNews(
		fields: readonly FieldOfNews[],
		filter: string,
		index: number,
		limit: number,
		orderBy: OrderBy<keyof News>[] | OrderBy<keyof News>,
	) {
		const url = new URL(AUTH_GET_NEWS);
		const params = url.searchParams;
		params.append('fields', fields.join(','));
		params.append('page', String(Math.floor(index / limit) + 1));
		params.append('limit', String(limit));
		if (filter) {
			params.append('filter', filter);
		}
		params.append('orderBy', Array.isArray(orderBy) ? orderBy.join(',') : String(orderBy));
		return this.http.get<News[]>(url.toString());
	}

	getNewsById(
		id: number,
		fields: readonly FieldOfNews[],
	) {
		const url = new URL(`${ AUTH_GET_NEWS }/${ id }`);
		const params = url.searchParams;
		params.append('fields', fields.join(','));

		return this.http.get<News>(url.toString());
	}

	getViewDocumentUrl(id: number, filename: string) {
		const url = new URL(`${ GET_ATTACHMENT_URL }/${ id }/${ filename }`);
		const params = url.searchParams;
		params.append('access_token', this.connectionService.getDownloadAccessToken());
		params.append('download', 'false');
		return url.toString();
	}
}
